<form style="width: 400px; min-width: 50%">
  <h1 mat-dialog-title>{{'Markets.General.addGenMarket.headerNew' | translate}}</h1>
  <div mat-dialog-content>
    <mat-form-field class="col-12">
      <mat-label>{{'Markets.General.lblCode' | translate}}</mat-label>
      <input type="text" matInput placeholder="{{'Markets.General.lblCode' | translate}}" [(ngModel)]="generalMarket.code" [ngModelOptions]="{standalone: true}" maxlength="10"/>
    </mat-form-field>
    <mat-form-field class="col-12">
      <mat-label>{{'Markets.General.lblDescription' | translate}}</mat-label>
      <input type="text" matInput placeholder="{{'Markets.General.lblDescription' | translate}}" [(ngModel)]="generalMarket.description" [ngModelOptions]="{standalone: true}"/>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="OnSaveAccount()">{{'btnSave' | translate}}</button>&nbsp;
    <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
  </div>
</form>